import { formatPeso, perUnit } from '@tahi/core';

/** 5 → '5', 1.5 → '1.5', 0.25 → '0.25'. */
export function numberText(n: number): string {
  return String(Math.round(n * 1000) / 1000);
}

/** '5 kg', '12', '' when there is no quantity. */
export function quantityText(quantity: number | null, unit: string | null): string {
  if (quantity == null) return unit ?? '';
  return unit ? `${numberText(quantity)} ${unit}` : numberText(quantity);
}

/** Reads a quantity the user typed: '5', '1.5', '1,5'. Null if empty or not above zero. */
export function parseQuantity(text: string): number | null {
  const t = text.trim().replace(',', '.');
  if (t === '' || !/^\d+(\.\d+)?$/.test(t)) return null;
  const n = Number(t);
  return n > 0 ? n : null;
}

/** '₱59/kg' or '₱7.50 each' for pieces. */
export function unitPriceText(minorPerUnit: number, unit: string): string {
  const amount = formatPeso(minorPerUnit);
  return unit === 'pc' ? `${amount} each` : `${amount}/${unit}`;
}

/** The price-per-unit text for a line, or null when it has no quantity (or is a single piece). */
export function lineUnitPrice(
  priceMinor: number,
  quantity: number | null,
  unit: string | null,
): string | null {
  const u = perUnit(priceMinor, quantity, unit);
  if (!u || (u.unit === 'pc' && u.baseQuantity === 1)) return null;
  return unitPriceText(u.minorPerUnit, u.unit);
}
